import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogContent, Paper, Stack, Typography } from "@mui/material";
import { ReviewContext } from "../../../../provider/MyContexts";
import { get } from "lodash";
import { ClearButton } from "../../components/MyIconButton";
import { StringObj } from "../../../../type";
import { getUserData } from "../../../../hooks/auth";

export default function CommentDialog(props: {
  open: boolean;
  handleClickOpen: () => void;
  handleClose: () => void;
}) {
  const { reviews, reviewState, updateComments, selectedId } = React.useContext(ReviewContext);

  const [input, setInput] = React.useState<string>("");
  const [comments, setComments] = React.useState<StringObj[]>([]);

  function resetState() {
    setInput("");
    setComments([]);
  }

  async function addComment(comment: string) {
    const userData = await getUserData();
    setComments((prev) => [
      ...prev,
      {
        user: (userData?.name as string) || "Unknown",
        comment: comment,
      },
    ]);
  }
  function removeComment(index: number) {
    setComments((prev) => prev.filter((_, i) => i !== index));
  }

  const targetReview = get(reviews, reviewState, []).find((i) => i.id === selectedId);

  React.useEffect(() => {
    if (targetReview) {
      setComments(targetReview.comments || []);
    } else {
      setComments([]);
    }
  }, [targetReview, props.open]);

  return (
    <Dialog
      open={props.open}
      onClose={() => {
        props.handleClose();
        resetState();
      }}
    >
      <DialogTitle>
        <Typography
          variant="label_L"
          sx={{
            fontWight: 500,
          }}
        >
          コメント
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{ width: "400px", minWidth: "300px", maxHeight: "500px", overflowY: "auto" }}
      >
        <Stack width={"100%"}>
          {comments.map((comment, index) => (
            <Paper
              key={index}
              variant="outlined"
              sx={{
                padding: 1,
                marginBottom: 1,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Stack direction={"column"} spacing={0.5}>
                <Typography fontWeight={600} color="gray" variant="label_M">
                  {comment.user}
                </Typography>
                <Typography variant="body_M">{comment.comment}</Typography>
              </Stack>
              <ClearButton onClick={() => removeComment(index)} />
            </Paper>
          ))}
        </Stack>
        <Stack direction={"row"} spacing={1} alignItems={"center"} width={"100%"} marginTop={2}>
          <TextField
            autoFocus
            margin="dense"
            id="comment"
            label="コメントを入力"
            // type="text"
            size="small"
            fullWidth
            variant="outlined"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && input.trim() !== "") {
                // addComment(input.trim());
                setInput("");
              }
            }}
            multiline
            rows={3}
          />
          <Button
            disabled={input.trim() === ""}
            variant="contained"
            onClick={() => {
              addComment(input.trim());
              setInput("");
            }}
          >
            追加
          </Button>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          size="small"
          onClick={() => {
            props.handleClose();
            resetState();
          }}
        >
          とじる
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={async () => {
            reviewState && (await updateComments(selectedId, reviewState, comments));
            props.handleClose();
            props.handleClose();
            resetState();
          }}
        >
          保存する
        </Button>
      </DialogActions>
    </Dialog>
  );
}
